import * as Types from '../../../../__generated__/graphql-base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetJobSeekerAccountKeyQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetJobSeekerAccountKeyQuery = {
    __typename?: 'Query';
    jobSeekerProfile?:
        | {
              __typename?: 'JobSeekerProfilePayload';
              profile?:
                  | { __typename?: 'JobSeekerProfile'; accountKey?: string | null | undefined }
                  | null
                  | undefined;
          }
        | null
        | undefined;
};

export const GetJobSeekerAccountKeyDocument = gql`
    query GetJobSeekerAccountKey {
        jobSeekerProfile {
            profile {
                accountKey
            }
        }
    }
`;

/**
 * __useGetJobSeekerAccountKeyQuery__
 *
 * To run a query within a React component, call `useGetJobSeekerAccountKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobSeekerAccountKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobSeekerAccountKeyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJobSeekerAccountKeyQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetJobSeekerAccountKeyQuery,
        GetJobSeekerAccountKeyQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetJobSeekerAccountKeyQuery, GetJobSeekerAccountKeyQueryVariables>(
        GetJobSeekerAccountKeyDocument,
        options,
    );
}
export function useGetJobSeekerAccountKeyLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetJobSeekerAccountKeyQuery,
        GetJobSeekerAccountKeyQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetJobSeekerAccountKeyQuery, GetJobSeekerAccountKeyQueryVariables>(
        GetJobSeekerAccountKeyDocument,
        options,
    );
}
export function useGetJobSeekerAccountKeySuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              GetJobSeekerAccountKeyQuery,
              GetJobSeekerAccountKeyQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        GetJobSeekerAccountKeyQuery,
        GetJobSeekerAccountKeyQueryVariables
    >(GetJobSeekerAccountKeyDocument, options);
}
export type GetJobSeekerAccountKeyQueryHookResult = ReturnType<
    typeof useGetJobSeekerAccountKeyQuery
>;
export type GetJobSeekerAccountKeyLazyQueryHookResult = ReturnType<
    typeof useGetJobSeekerAccountKeyLazyQuery
>;
export type GetJobSeekerAccountKeySuspenseQueryHookResult = ReturnType<
    typeof useGetJobSeekerAccountKeySuspenseQuery
>;
export type GetJobSeekerAccountKeyQueryResult = Apollo.QueryResult<
    GetJobSeekerAccountKeyQuery,
    GetJobSeekerAccountKeyQueryVariables
>;
